module.exports = __webpack_public_path__ + "img/register_02.24dbd32e.png";